import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Holding from "../views/Holding.vue";
import News from "../views/News.vue";
import ForumTopics from "../views/ForumTopics.vue";
import ForumBoards from "../views/ForumBoards.vue";
import ForumPostView from "../views/ForumPostView.vue";
import ForumNew from "../views/ForumNew.vue";
import ForumPostMutate from "../views/ForumPostMutate.vue";
import PalmInfo from "../views/PalmInfo.vue";
import Register from "../views/Register.vue";
import RegistrationProcessed from "../views/RegistrationProcessed.vue";
import ConfirmRegistration from "../views/ConfirmRegistration.vue";
import Contact from "../views/Contact.vue";
import LoginPage from "../views/LoginPage.vue";
import NewsLetter from "../views/NewsLetter.vue";
import PasswordReset from "../views/PasswordReset.vue";
import SendPasswordResetLink from "../views/SendPasswordResetLink.vue";
import ManageProfile from "../views/ManageProfile.vue";
import Nurseries from "../views/Nurseries.vue";
import Links from "../views/Links.vue";
import Mail from "../views/Mail.vue";
import SiteAdmin from "../views/SiteAdmin.vue";
import SiteTools from "../views/SiteTools.vue";

import userFunctions from "../functions/userFunctions";

import NewsNew from "../views/NewsMutate.vue";
import NewsEdit from "../views/NewsMutate.vue";

import JournalNew from "../views/JournalMutate.vue";
import JournalEdit from "../views/JournalMutate.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/holding",
    name: "Holding",
    component: Holding,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/news",
    name: "News",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/News.vue')
    component: News,
  },
  {
    path: "/newsletter",
    name: "NewsLetter",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/News.vue')
    component: NewsLetter,
  },
  {
    path: "/palminfo",
    name: "PalmInfo",
    component: PalmInfo,
  },
  {
    path: "/forumboardlist",
    name: "ForumBoards",
    component: ForumBoards,
  },
  {
    path: "/forumboardlist/:search",
    name: "ForumBoardsSearch",
    component: ForumBoards,
  },
  {
    path: "/forum/:board_id",
    name: "ForumTopics",
    component: ForumTopics,
  },
  {
    path: "/forum/:board_id/:search",
    name: "ForumTopicsSearch",
    component: ForumTopics,
  },
  {
    path: "/post/:board_id/:topic_id",
    name: "ForumPostViewTopic",
    component: ForumPostView,
  },
  {
    path: "/post/:board_id/:topic_id/:post_id",
    name: "ForumPostViewPost",
    component: ForumPostView,
  },
  {
    path: "/news/new",
    name: "NewsNew",
    component: NewsNew,
  },
  {
    path: "/news/edit/:newsId",
    name: "NewsEdit",
    component: NewsEdit,
  },
  {
    path: "/journal/edit/:journalId",
    name: "JournalEdit",
    component: JournalEdit,
  },
  {
    path: "/journal/new",
    name: "JournalNew",
    component: JournalNew,
  },
  {
    path: "/forumpost/new/:board_id/:title",
    name: "AddTopicToBoard",
    component: ForumPostMutate,
  },
  {
    path: "/forumpost/new/:board_id/:topic_id",
    name: "ForumPostMutateWithTopic",
    component: ForumPostMutate,
  },
  {
    path: "/forumpost/reply/:board_id/:topic_id/:post_id/:title",
    name: "ForumPostReplyToTopic",
    component: ForumPostMutate,
  },
  {
    path: "/forumpost/quote/:board_id/:topic_id/:post_id/:title",
    name: "ForumPostQuoteReplyToPost",
    component: ForumPostMutate,
  },
  {
    path: "/forumpost/edit/:board_id/:topic_id/:post_id",
    name: "ForumPostEdit",
    component: ForumPostMutate,
  },
  {
    path: "/forumnew",
    name: "ForumNew",
    component: ForumNew,
  },
  {
    path: "/mail",
    name: "Mail",
    component: Mail,
  },
  {
    path: "/mail/:userId",
    name: "MailToUser",
    component: Mail,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/login/:status",
    name: "LoginWithStatus",
    component: LoginPage,
  },
  {
    path: "/newsletter",
    name: "Newsletter",
    component: PalmInfo,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/registrationprocessed",
    name: "RegistrationProcessed",
    component: RegistrationProcessed,
  },
  {
    path: "/confirmregistration/:token",
    name: "ConfirmRegistration",
    component: ConfirmRegistration,
  },
  {
    path: "/links",
    name: "Links",
    component: Links,
  },
  {
    path: "/nurseries",
    name: "Nurseries",
    component: Nurseries,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/manageprofile",
    name: "MangeProfile",
    component: ManageProfile,
  },
  {
    path: "/passwordreset/:token",
    name: "PasswordReset",
    component: PasswordReset,
  },
  {
    path: "/sendpasswordresetlink",
    name: "SendPasswordResetLink",
    component: SendPasswordResetLink,
  },
  {
    path: "/siteadmin",
    name: "SiteAdmin",
    component: SiteAdmin,
  },
  {
    path: "/siteadmin/:search",
    name: "SiteAdminSearch",
    component: SiteAdmin,
  },
  {
    path: "/sitetools",
    name: "SiteTools",
    component: SiteTools,
  },
  { path: "/journals" },
  { path: "/imported" },
  { path: "/rome" },
  { path: "/robots.txt" },
  { path: "/eps_banner.png" },
  { path: "/google200c58205102d770.html" },
  { path: "/sitemap.xml" },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  let siteIsLive = process.env.VUE_APP_LIVE == "true";

  let userIsAdmin =
    userFunctions.userIsLoggedIn() &&
    (userFunctions.currentUserIsOwner() ||
      userFunctions.currentUserIsModerator());
  //TODO - reload on ver?
  if (
    !siteIsLive &&
    to.name != "Holding" && to.name != "Login" &&
    !userIsAdmin
  ) {
    return next("/holding");
  }

  const publicPages = [
    "/holding",
    "/login",
    "/news",
    "/palminfo",
    "/register",
    "/registrationprocessed",
    "/confirmregistration",
    "/links",
    "/nurseries",
    "/contact",
    "/",
    "/passwordreset",
    "/sendpasswordresetlink",
  ];
  const forumPages = ["/forumboardlist", "/forum", "/post"];

  let pageRoot = to.path == "/" ? "/" : "/" + to.path.split("/")[1];

  const authRequired =
    !publicPages.includes(pageRoot) && !forumPages.includes(pageRoot);
  const loggedIn = userFunctions.userIsLoggedIn();

  if (authRequired && !loggedIn) {
    return next("/login");
  }
  next();
});

// const siteMapRoutes = router.options.routes
//   .map((r) => r.path)
//   .filter((r) => !r.includes(":")) // removes routes with params
//   .map((r) => `<url><loc>https://www.palmsociety.org.uk${r}</loc></url>`);
// console.log(`
//     <?xml version='1.0' encoding='UTF-8'?>
//     <urlset xmlns='http://www.sitemaps.org/schemas/sitemap/0.9'>
//         ${siteMapRoutes.join("\n")}
//     </urlset>
//   `);

export default router;
